import clsx from 'clsx';

import { Skeleton } from '../../../feedback/skeleton';

type Props = { className?: string };

export const RowSkeleton = ({ className }: Props) => {
  return (
    <div className={clsx('DS-Table-RowSkeletonWrapper', className)}>
      <Skeleton className="DS-Table-RowSkeleton" />
    </div>
  );
};
